<template lang="pug">
.case-container
  .case-content
    .case-case__title
        .divider
        .title__content
          span {{ $t('案例分享：某出行平台') }}
          span {{ $t('国内知名的出行平台。') }}
    .case-case__summary
      div
        i.iconfont.iconhangye
        span {{ $t('广告主行业：交通出行') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('为该企业市场部搭建媒介数据管理系统，高效整合、对比、分析数据。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('客户内部各个事业线负责各自的广告投放，媒介排期数据、实际投放数据、各渠道花费数据过于分散，不透明，都是线下的数据报表。高层老板不清楚每个渠道的相关表现，每当想要了解时需找相关负责同事去查询。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content {{ $t('我们为客户搭建了一个媒介数据管理系统，通过三大功能解决客户的痛点。') }}
        .content 1）{{ $t('排期录入模块：所有线上及线下投放渠道的排期均可一键录入系统，并且系统自动读取排期数据，即使负责员工离职或换部门，相关已确认排期及物料，有据可查，绝不遗失。') }}
        .content 2）{{ $t('数据分析模块：支持多维度组合查看数据，层级上可以跨事业群、事业线、区域。维度上可以跨媒介、渠道、供应商、媒体、市场查看数据。所有数据将通过数字化形式存储在云端，无论是历史数据还是当前数据，既可在线查看，也可一键查询。') }}
        .content 3）{{ $t('用户中心模块：不同部门仅支持查看及编辑自己所在部门的市场营销活动，合理划分权限，互不影响。供应商与内部员工权限区分明确，绝不会泄露任何信息。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('客户管理层更加便捷、高效的查看所有渠道的营销表现数据，包含实际数据与排期数据的对比、不同渠道间的表现对比、不同事业线间的花费对比、不同供应商之间的效果对比等等。同时该系统支持PC版及移动版，便于客户无论是办公室办公还是外出移动办公，均可随时查询数据表现。') }}
  MobileContact
</template>"
<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    MobileContact
  }
}
</script>
